const JANELA_CHUVA_24H_MS = 24 * 60 * 60 * 1000;

function timestampLeitura(leitura) {
  const data = new Date(leitura?.timestamp || leitura?.data_local || leitura?.created_at || '');
  return Number.isNaN(data.getTime()) ? null : data.getTime();
}

export function calcularChuvaUltimas24Horas(leituras, referencia = new Date()) {
  const fim = referencia instanceof Date ? referencia.getTime() : new Date(referencia).getTime();
  if (!Number.isFinite(fim)) return null;
  const inicio = fim - JANELA_CHUVA_24H_MS;
  let encontrouValor = false;
  let total = 0;

  (leituras || []).forEach(leitura => {
    const timestamp = timestampLeitura(leitura);
    if (timestamp === null || timestamp < inicio || timestamp > fim) return;
    if (leitura?.rain_mm === null || leitura?.rain_mm === undefined || leitura?.rain_mm === '') return;
    const chuva = Number(leitura.rain_mm);
    if (!Number.isFinite(chuva) || chuva < 0) return;
    encontrouValor = true;
    total += chuva;
  });

  return encontrouValor ? Number(total.toFixed(2)) : null;
}
